<template>
  <section class="fake-deals-board">
    <div class="background" :class="state"></div>
    <div class="content-container" :class="currentStage.orientation">
      <div class="content">
        <component
          :is="currentStage.component"
          :state="currentStage.state"
          :errors="errors"
          @state:changed="(state) => currentStage.state = state"
          @success="handleSuccess"
        />
        <div
          v-if="currentStage.showProgressBar"
          class="progress-bar-outer"
        >
          <span :style="{width: progress}" class="progress-bar-inner"></span>
        </div>
        <img class="logo" src="/build/images/salesflow_branco.svg" alt="Salesflow"/>
      </div>
    </div>
  </section>
</template>

<script>
import GetToKnowYouForm from './GetToKnowYouForm.vue';
import FewMoreInformationForm from './FewMoreInformationForm.vue';
import CongratulationsContent from './CongratulationsContent.vue';
import WaitEnvironmentSetup from './WaitEnvironmentSetup.vue';

export default {
  components: {
    GetToKnowYouForm,
    FewMoreInformationForm,
    CongratulationsContent,
    WaitEnvironmentSetup,
  },

  props: {
    user: {
      type: Object,
      required: true,
    }
  },

  data () {
    return {
      currentStageIndex: 0,
      stages: [
        {
          id: 'get-to-know-you-form',
          component: 'GetToKnowYouForm',
          orientation: 'vertical',
          showProgressBar: true,
          state: {
            phone: {
              number: null,
              details: null,
            },
            occupation: {
              options: [
                { name: 'Administrador' },
                { name: 'Empresário / CEO' },
                { name: 'Diretor comercial' },
                { name: 'Gestor de vendas' },
                { name: 'Profissional de marketing' },
                { name: 'Supervisor(a) / Coordenador(a)' },
                { name: 'Profissional de TI' },
                { name: 'Vendedor externo' },
              ],
              selected: { name: '' },
            },
            experience: {
              options: [
                { name: 'Primeira vez utilizando uma plataforma de CRM' },
                { name: 'Utilizo planilha para acompanhar minhas vendas' },
                { name: 'Já utilizei outro CRM para minhas atividades de vendas' },
                { name: 'Sou expert em implantação e utilização de CRM' },
              ],
              selected: { name: '' },
            },
            goal: {
              options: [
                { name: 'Fechar mais negócios em menos tempo' },
                { name: 'Atrair e encontrar novos leads e oportunidades' },
                { name: 'Gerenciar os relacionamentos com meus leads e clientes' },
                { name: 'Organizar meus processos de vendas e marketing' },
                { name: 'Gerenciar o progresso e resultados da minha equipe' },
                { name: 'Outros' },
              ],
              selected: { name: '' },
            },
          },
          successHandler: 'defaultSuccessHandler',
        },
        {
          id: 'few-more-information-form',
          component: 'FewMoreInformationForm',
          orientation: 'vertical',
          showProgressBar: true,
          state: {
            company: '',
            segment: {
              options: [
                {name: 'Agricultura'},
                {name: 'Turismo / Viagens'},
                {name: 'Energia'},
                {name: 'Fabricação'},
                {name: 'Administração'},
                {name: 'Construção'},
                {name: 'TI'},
                {name: 'Marketing'},
                {name: 'Distribuidora'},
                {name: 'Imobiliária'},
                {name: 'Advocacia'},
                {name: 'Educação'},
                {name: 'Saúde e serviços sociais'},
                {name: 'Eventos'},
                {name: 'Indústria'},
                {name: 'Corretora de seguros'},
                {name: 'Contabilidade'},
                {name: 'Automotivo'},
                {name: 'Outro'}
              ],
              selected: { name: '' },
            },
            employees: {
              options: [
                {name: '1'},
                {name: '2-5'},
                {name: '6-10'},
                {name: '11-50'},
                {name: '51-100'},
                {name: '101-250'},
                {name: '251-500'},
                {name: '501-1000'}
              ],
              selected: { name: '1' },
            },
            role: {
              options: [
                {name: 'Comercial'},
                {name: 'Administrador'}
              ],
              selected: { name: 'Comercial' }
            },
            invitations: [
              {
                email: '',
                role: 'Comercial'
              }
            ],
            numberOfUsers: null,
            isInviteOpen: false
          },
          successHandler: 'defaultSuccessHandler',
        },
        {
          id: 'congratulations-content',
          component: 'CongratulationsContent',
          orientation: 'vertical',
          showProgressBar: true,
          state: {
            mockData: true,
          },
          successHandler: 'handleCongratulationsContentSuccess',
        },
        {
          id: 'wait-environment-setup',
          component: 'WaitEnvironmentSetup',
          orientation: 'horizontal',
          showProgressBar: false,
          state: null,
          successHandler: null,
        },
      ],
      errors: null,
    };
  },

  computed: {
    state () {
      const stage = this.getStage('congratulations-content');

      return stage.state.mockData ? 'full' : 'empty';
    },

    currentStage() {
      return this.stages[this.currentStageIndex];
    },

    progress() {
      const progressBarStages = this.stages.filter((stage) => stage.showProgressBar);

      const total = progressBarStages.length;
      const current = this.currentStageIndex;

      return `${(current + 1) / total * 100}%`;
    },
  },

  methods: {
    advance () {
      this.currentStageIndex = Math.min(this.stages.length - 1, this.currentStageIndex + 1);
    },

    getStage (id) {
      return this.stages.find((stage) => stage.id === id);
    },

    convert (data, stage) {
      const payload = {
        ...this.user,
        ...data,
        identifier: `trial_salesflow_step-${stage}`,
        token: window.BulldeskSettings?.token,
        origin: window.location.origin,
        phone: data?.phone?.details?.number?.replace(/\D/g, ''),
        occupation: data?.occupation?.selected?.name,
        origin: "Salesflow - início trial"
      };

      this.$http.post('/api/conversion', payload).catch((response) => {
        console.error(response);
      });
    },

    handleSuccess (state) {
      if (!this.currentStage.successHandler) {
        return;
      }

      this[this.currentStage.successHandler](state);
    },

    defaultSuccessHandler (state) {
      this.currentStage.state = state;

      this.convert(state, this.currentStageIndex + 2);

      this.advance();
    },

    handleCongratulationsContentSuccess () {
      this.advance();

      const payload = this.assembleRegisterPayload();

      this.register(payload);
    },

    assembleRegisterPayload () {
      const getToKnowYouFormData = this.getStage('get-to-know-you-form').state;
      const fewMoreInformationFormData = this.getStage('few-more-information-form').state;
      const congratulationsContentData = this.getStage('congratulations-content').state;

      return {
        phone: getToKnowYouFormData.phone?.details?.number?.replace(/\D/g, ''),
        occupation: getToKnowYouFormData.occupation?.selected?.name,
        experience: getToKnowYouFormData.experience?.selected?.name,
        goal: getToKnowYouFormData.goal?.selected?.name,
        company: fewMoreInformationFormData.company,
        segment: fewMoreInformationFormData.segment?.selected?.name,
        employees: fewMoreInformationFormData.employees?.selected?.name,
        users: fewMoreInformationFormData.numberOfUsers,
        invitations: fewMoreInformationFormData.invitations.filter((invitation) => invitation.email.length),
        email: this.user?.email,
        initial_fake_data: congratulationsContentData.mockData,
        terms: true,
      };
    },

    register (payload) {
      this.$http.post('/register', payload).then(() => {
          window.location = '/deal';
      }).catch((response) => {
        console.error(response);

        if (response.status === 422) {
          const message = response.data?.message ? response.data.message
            : 'Falha ao realizar cadastro, preencha os campos novamente';

          this.errors = response.data;

          Alert.error(this.__(message));
        } else {
          Alert.error(this.__('Ocorreu um erro inesperado ao realizar o seu cadastro'));
        }

        setTimeout(() => {
          response.status == 422 ? this.currentStageIndex = 0 : window.location.reload();
        }, 2000);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

.fake-deals-board {
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  .background {
    width: 100%;
    height: 100%;
    position: absolute;
    background-size: auto;
    background-attachment: fixed;
    background-repeat: no-repeat;

    &.full {
      background-image: url('/build/images/auth/fake-deals-board/full-926x428.webp');
    }

    &.empty {
      background-image: url('/build/images/auth/fake-deals-board/empty-926x428.webp');
    }
  }

  .content-container {
    width: 100%;
    max-height: 665px;
    bottom: 0px;
    position: absolute;
    border-radius: 20px 20px 0px 0px;
    background: #FBFBFB;
    box-shadow: -8px 0px 56px 0px rgba(134, 134, 134, 0.08);
    z-index: 10;
    transition: padding 0.5s;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &.horizontal {
      padding: 40px 64px;
    }

    &.vertical {
      padding: 40px 32px;
    }

    .content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1.5rem;

      .progress-bar-outer {
        width: 100%;
        height: 2px;
        display: flex;
        align-items: start;
        background: $salesflow-outline-gray-light;
        border-radius: 8px;

        .progress-bar-inner {
          height: 100%;
          background: $salesflow-primary;
          border-radius: 8px;
          transition: all 1s;
        }
      }

      .logo {
        width: 9.25rem;
      }
    }
  }

  .content-container::-webkit-scrollbar {
    display: none;
  }
}

.fake-deals-board:has(.wait-environment-setup) .background.full {
  background-image: url('/build/images/auth/fake-deals-board/full-wait-message-926x428.webp') !important;
}

.fake-deals-board:has(.wait-environment-setup) .background.empty {
  background-image: url('/build/images/auth/fake-deals-board/empty-wait-message-926x428.webp') !important;
}

.fake-deals-board:has(.wait-environment-setup) .content-container {
  position: relative;
  border-radius: 40px;
  max-height: 341px;
  width: 373px;
}

.fake-deals-board:has(.congratulations-content) .content-container {
  max-height: 517px;
}

@media (max-height: 740px) and (max-width: 425px) {
  .fake-deals-board {
    .content-container {
      min-height: 100vh !important;
      width: 100vw;
      border-radius: 0px;
    }
  }

  .fake-deals-board:has(.wait-environment-setup) .content-container {
    min-height: auto !important;
  }

  .fake-deals-board:has(.congratulations-content) .content-container {
    min-height: auto !important;
    border-radius: 20px 20px 0 0;
  }
}

@media (min-width: 428px) and (max-width: 743px){
  .fake-deals-board {
    .background {
      background-size: contain;
    }
  }
  .fake-deals-board:has(.wait-environment-setup) {
    .background {
      background-size: cover;
    }
  }
}

/* Media query para mobile na horizontal */
@media (max-height: 540px) and (min-width: 741px) {
  .fake-deals-board {
    .content-container {
      overflow: auto !important;
      max-height: 95% !important;
      min-height: 95% !important;
      bottom: 50% !important;
      transform: translateY(50%) !important;
    }
  }

  .fake-deals-board:has(.wait-environment-setup) .content-container {
    bottom: auto !important;
    transform: translateY(0) !important;
    max-height: 341px !important;
    width: 373px !important;
  }

  .fake-deals-board:has(.wait-environment-setup) .background {
    background-size: cover !important;
  }
}

/* Media query específico para mobiles menores na horizontal */
@media (max-height: 540px) and (max-width: 740px) {
  .fake-deals-board {
    .content-container {
      max-height: 100% !important;
      border-radius: 0;
    }
  }

  .fake-deals-board:has(.congratulations-content) .content-container {
    overflow: auto !important;
    max-height: 95% !important;
    min-height: 95% !important;
    bottom: 50% !important;
    transform: translateY(50%) !important;
    width: auto !important;
    border-radius: 20px;
  }

  .fake-deals-board:has(.congratulations-content) .background {
    background-size: cover;
  }
}

/* Media query para tablets */
@media (min-width: 744px) {
  .fake-deals-board:has(.wait-environment-setup) .background.full {
    background-image: url('/build/images/auth/fake-deals-board/full-1133x744.webp') !important;
  }

  .fake-deals-board:has(.wait-environment-setup) .background.empty {
    background-image: url('/build/images/auth/fake-deals-board/empty-1133x744.webp') !important;
  }

  .fake-deals-board:has(.congratulations-content) .content-container {
    max-height: 535px;
  }

  .fake-deals-board:has(.wait-environment-setup) .content-container {
    height: 304px;
    width: 608px;
  }

  .fake-deals-board {
    padding: 1rem;
    .background {
      background-size: cover;
      &.full {
        background-image: url('/build/images/auth/fake-deals-board/full-1133x744.webp');
      }

      &.empty {
        background-image: url('/build/images/auth/fake-deals-board/empty-1133x744.webp');
      }
    }
    .content-container {
      bottom: auto;
      border-radius: 40px;
      width: 608px;
      max-height: 100%;
      &.horizontal {
        padding: 40px 80px;
      }

      &.vertical {
        padding: 40px 80px;
      }
      .content {
        width: 100%;
      }
    }
  }
}

@media (min-width: 1024px) {
  .fake-deals-board {
    .content-container {
      &.horizontal {
        padding: 40px 136px;
      }
    }
  }
}

@media (min-width: 1280px) {
  .fake-deals-board:has(.wait-environment-setup) .background.full {
    background-image: url('/build/images/auth/fake-deals-board/full-1280x724.webp') !important;
  }
  .fake-deals-board:has(.wait-environment-setup) .background.empty {
    background-image: url('/build/images/auth/fake-deals-board/empty-1280x724.webp') !important;
  }
  .fake-deals-board:has(.wait-environment-setup) .content-container {
    position: static;
    border-radius: 40px;
    height: auto;
    width: auto;
  }
  .fake-deals-board:has(.congratulations-content) .content-container {
    height: auto;

    &.vertical {
      padding: 40px 136px;
    }

  }
  .fake-deals-board {
    .background {
      background-size: cover;
      &.full {
        background-image: url('/build/images/auth/fake-deals-board/full-1280x724.webp');
      }

      &.empty {
        background-image: url('/build/images/auth/fake-deals-board/empty-1280x724.webp');
      }
    }
    .content-container {
      width: auto;
      height: auto;
      bottom: auto;
      position: static;
      border-radius: 40px;
      &.horizontal {
        padding: 2.5rem 8.5rem;
      }

      &.vertical {
        padding: 2.5rem 5rem;
      }

      .content {
        width: 28rem;
      }
    }
  }
}

@media (min-width: 1440px) {
  .fake-deals-board:has(.wait-environment-setup) .background.full {
    background-image: url('/build/images/auth/fake-deals-board/full-1440x1366.webp') !important;
  }
  .fake-deals-board:has(.wait-environment-setup) .background.empty {
    background-image: url('/build/images/auth/fake-deals-board/empty-1440x1366.webp') !important;
  }
  .fake-deals-board:has(.wait-environment-setup) .content-container {
    position: static;
    border-radius: 40px;
    height: auto;
    width: auto;
  }
  .fake-deals-board:has(.congratulations-content) .content-container {
    height: auto;
  }
  .fake-deals-board {
    .background {
      background-size: cover;
      &.full {
        background-image: url('/build/images/auth/fake-deals-board/full-1440x1366.webp');
      }

      &.empty {
        background-image: url('/build/images/auth/fake-deals-board/empty-1440x1366.webp');
      }
    }
    .content-container {
      width: auto;
      height: auto;
      bottom: auto;
      position: static;
      &.horizontal {
        padding: 2.5rem 8.5rem;
      }

      &.vertical {
        padding: 2.5rem 5rem;
      }

      .content {
        width: 28rem;
      }
    }
  }
}

@media (min-width: 1920px) {
  .fake-deals-board:has(.wait-environment-setup) .background.full {
    background-image: url('/build/images/auth/fake-deals-board/full-1920x1082.webp') !important;
  }
  .fake-deals-board:has(.wait-environment-setup) .background.empty {
    background-image: url('/build/images/auth/fake-deals-board/empty-1920x1082.webp') !important;
  }
  .fake-deals-board:has(.wait-environment-setup) .content-container {
    position: static;
    border-radius: 40px;
    height: auto;
    width: auto;
  }
  .fake-deals-board:has(.congratulations-content) .content-container {
    height: auto;
  }
  .fake-deals-board {
    .background {
      background-size: cover;
      &.full {
        background-image: url('/build/images/auth/fake-deals-board/full-1920x1082.webp');
      }

      &.empty {
        background-image: url('/build/images/auth/fake-deals-board/empty-1920x1082.webp');
      }
    }
    .content-container {
      width: auto;
      height: auto;
      bottom: auto;
      position: static;
      border-radius: 40px;
      &.horizontal {
        padding: 2.5rem 8.5rem;
      }

      &.vertical {
        padding: 2.5rem 5rem;
      }

      .content {
        width: 28rem;
      }
    }
  }
}

@media (min-width: 2560px) {
  .fake-deals-board:has(.wait-environment-setup) .background.full {
    background-image: url('/build/images/auth/fake-deals-board/full-2560x1442.webp') !important;
  }
  .fake-deals-board:has(.wait-environment-setup) .background.empty {
    background-image: url('/build/images/auth/fake-deals-board/empty-2560x1442.webp') !important;
  }
  .fake-deals-board:has(.wait-environment-setup) .content-container {
    position: static;
    border-radius: 40px;
    height: auto;
    width: auto;
  }
  .fake-deals-board:has(.congratulations-content) .content-container {
    height: auto;
  }
  .fake-deals-board {
    .background {
      background-size: cover;
      &.full {
        background-image: url('/build/images/auth/fake-deals-board/full-2560x1442.webp');
      }

      &.empty {
        background-image: url('/build/images/auth/fake-deals-board/empty-2560x1442.webp');
      }
    }
    .content-container {
      width: auto;
      height: auto;
      bottom: auto;
      position: static;
      border-radius: 40px;
      &.horizontal {
        padding: 2.5rem 8.5rem;
      }

      &.vertical {
        padding: 2.5rem 5rem;
      }

      .content {
        width: 28rem;
      }
    }
  }
}


</style>
